import { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Typography, Alert } from "antd";

const { Title } = Typography;
const { TextArea } = Input;

const AdminConfirmRemovalModal = ({ open, onCancel, onConfirm, passengerData }) => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && passengerData) {
      form.setFieldsValue({
        remarks: passengerData.remarks || ""
      });
    }
  }, [open, passengerData, form]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await onConfirm({
        ...passengerData,
        remarks: values.remarks,
      });
      form.resetFields();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      title={<Title level={4} style={{ margin: 0, color: 'white' }}>Remove Passenger</Title>}
      className="ouber-modal white-close-icon"
      width={400}
      zIndex={1070}
      closable={!loading}
    >
      <div style={{ marginTop: '20px' }}>
        <Alert 
          message={`Are you sure you want to remove ${passengerData?.name || (passengerData?.first_name ? (passengerData.first_name + ' ' + (passengerData.last_name || "")) : 'this passenger')} from the roster? This will update their request status to Declined.`} 
          type="warning" 
          showIcon 
          style={{ marginBottom: '16px' }}
        />

        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item name="remarks" label="Remarks">
            <TextArea rows={3} placeholder="Add remarks or reasoning for removal..." />
          </Form.Item>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "24px" }}>
            <Button onClick={onCancel} disabled={loading}>Cancel</Button>
            <Button type="primary" danger htmlType="submit" loading={loading}>
              Confirm
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default AdminConfirmRemovalModal;
